import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { withRouter } from "react-router";

const VerdaderoFalso = (props) => {
  return (
    <Form.Group>
      <Row>
        <Form.Group
          as={Col}
          className="mb-3 inputHover"
          sm="12"
          md="12"
          lg="12"
          xl="12"
        >
          <Row className="pl-3 pr-3">
            <Col
              xs="1"
              sm="1"
              md="1"
              lg="1"
              xl="1"
              className="d-flex flex-wrap justify-content-center align-items-center"
            >
              <span className="d-flex flex-wrap justify-content-center align-items-center">
                <i className="material-icons" style={{ color: "##495057" }}>
                  radio_button_unchecked
                </i>
              </span>
            </Col>
            <Col
              xs="5"
              sm="5"
              md="5"
              lg="5"
              xl="5"
              className="d-flex flex-wrap justify-content-center align-items-center"
            >
              <Form.Control
                name="opción1"
                className="rounded-pill"
                required
                disabled
                value={props.descrip}
                type="text"
                pattern="^[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]+$"
                placeholder="Opción 1"
              ></Form.Control>
            </Col>
          </Row>
        </Form.Group>
      </Row>
    </Form.Group>
  );
};

export default withRouter(VerdaderoFalso);
